<template>
    <div class="banner">
        <swiper v-bind="swiperOptions" class="mySwiper">
            <swiper-slide>
                <div class="slide_container">
                    <div class="mobile-bg_container">
                        <div class="mbl_img_container">
                            <img width="256" height="270" type="image/jpeg"
                                src="~/assets/friendly-services/cody_stephanie.png" alt="cody_stephanie">
                        </div>
                        <div class="mbl_img_container d-block d-lg-none">
                            <img width="256" height="270" type="image/jpeg"
                                src="~/assets/friendly-services/cody_stephanie_ring.png" alt="hands joining">
                        </div>
                    </div>

                    <div class="review-container text-center">
                        <img src="~/assets/friendly-services/inverted_comma.svg" alt="svg" width="26" height="29">
                        <p class="review">“From choosing the perfect diamond to the setting, thank you Friendly
                            diamonds for making
                            such a
                            special day that much better!”</p>
                        <p class="reviewer">Cody & Stephanie</p>

                        <div class="star-imgs_container">
                            <img v-for="i in 5" :key="i" src="~/assets/friendly-services/green_star.svg" alt="star_svg"
                                width="22" height="22">
                        </div>
                    </div>
                    <div class="img_container d-none d-lg-block">
                        <img width="256" height="270" type="image/jpeg"
                            src="~/assets/friendly-services/cody_stephanie_ring.png" alt="hands joining">
                    </div>

                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="slide_container">
                    <div class="mobile-bg_container">
                        <div class="mbl_img_container">
                            <img width="256" height="270" type="image/jpeg"
                                src="~/assets/friendly-services/isaiah_claira.png" alt="isaiah and claira">
                        </div>
                        <div class="mbl_img_container d-block d-lg-none">
                            <img width="256" height="270" type="image/jpeg"
                                src="~/assets/friendly-services/isaiah_claira_ring.png" alt="isaiah_claira_ring">
                        </div>
                    </div>

                    <div class="review-container text-center">
                        <img src="~/assets/friendly-services/inverted_comma.svg" alt="svg" width="26" height="29">
                        <p class="review">“For the beautiful Friendly Diamond ring in my hands and her instant yes,
                            thank you Friendly Diamonds, for the best day ever! ”</p>
                        <p class="reviewer">Isaiha & Claira</p>

                        <div class="star-imgs_container">
                            <img v-for="i in 5" :key="i" src="~/assets/friendly-services/green_star.svg" alt="star_svg"
                                width="22" height="22">
                        </div>
                    </div>
                    <div class="img_container d-none d-lg-block">
                        <img width="256" height="270" type="image/jpeg"
                            src="~/assets/friendly-services/isaiah_claira_ring.png" alt="isaiah_claira_ring">
                    </div>

                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="slide_container">
                    <div class="mobile-bg_container">
                        <div class="mbl_img_container">
                            <img width="256" height="270" type="image/jpeg"
                                src="~/assets/friendly-services/brendon_amy.png" alt="brendon_amy">
                        </div>
                        <div class="mbl_img_container d-block d-lg-none">
                            <img width="256" height="270" type="image/jpeg"
                                src="~/assets/friendly-services/brendon_amy_ring.png" alt="brendon_amy_ring">
                        </div>
                    </div>

                    <div class="review-container text-center">
                        <img src="~/assets/friendly-services/inverted_comma.svg" alt="svg" width="26" height="29">
                        <p class="review">“Amy and I eloped 3 years after our first kiss for a private ceremony and
                            her ring from Friendly Diamonds is as beautiful as her!”</p>
                        <p class="reviewer">Brendon & Amy</p>

                        <div class="star-imgs_container">
                            <img v-for="i in 5" :key="i" src="~/assets/friendly-services/green_star.svg" alt="star_svg"
                                width="22" height="22">
                        </div>
                    </div>
                    <div class="img_container d-none d-lg-block">
                        <img width="256" height="270" type="image/jpeg"
                            src="~/assets/friendly-services/brendon_amy_ring.png" alt="brendon_amy_ring">
                    </div>

                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="slide_container">
                    <div class="mobile-bg_container">
                        <div class="mbl_img_container">
                            <img width="256" height="270" type="image/jpeg"
                                src="~/assets/friendly-services/tyler_gabrielle.png" alt="tyler_gabrielle">
                        </div>
                        <div class="mbl_img_container d-block d-lg-none">
                            <img width="256" height="270" type="image/jpeg"
                                src="~/assets/friendly-services/tyler_gabrielle_ring.png" alt="tyler_gabrielle_ring">
                        </div>
                    </div>

                    <div class="review-container text-center">
                        <img src="~/assets/friendly-services/inverted_comma.svg" alt="svg" width="26" height="29">
                        <p class="review">“Getting down on one knee and proposing to my forever was incredible!
                            Thank you Friendly Diamonds for the amazing experience.”</p>
                        <p class="reviewer">Tyler & Gabrielle</p>

                        <div class="star-imgs_container">
                            <img v-for="i in 5" :key="i" src="~/assets/friendly-services/green_star.svg" alt="star_svg"
                                width="22" height="22">
                        </div>
                    </div>
                    <div class="img_container d-none d-lg-block">
                        <img width="256" height="270" type="image/jpeg"
                            src="~/assets/friendly-services/tyler_gabrielle_ring.png" alt="tyler_gabrielle_ring">
                    </div>

                </div>
            </swiper-slide>
        </swiper>
    </div>

</template>

<script setup>
import { Pagination,EffectFade } from 'swiper/modules';

const swiperOptions = {
    // loop: true,
    // modules: [SwiperAutoplay],
    modules: [Pagination, SwiperAutoplay, EffectFade],
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    pagination: {
        clickable: true,
        disableOnInteraction: false,
    },
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },

};
</script>

<style scoped>
/* common */
.show_mobile {
    display: block;
}

.show_desktop {
    display: none;
}


img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}

:global(.swiper-slide) {
    padding-bottom: 30px;
}

:global(.swiper-pagination-bullet) {
    width: 70px;
    height: 4px;
    border-radius: 8px;
    background-color: #eaeaea;
    opacity: 1;
}

:global(.swiper-pagination-bullet-active) {
    background-color: #c4c4c4;
}


.slide_container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex-wrap: wrap;
}

.mbl_img_container {
    width: 40%;
}

.review-container {
    width: 100%;
}

.review {
    padding-top: 10px;
}


@media(max-width:992px) {
    .mobile-bg_container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: url('~/assets/friendly-services/hearts_mobile.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: top center;
    }
}

.review-container p {
    font-size: 14px;
    color: #353535;
    line-height: 22px;
    font-style: italic;
}

.reviewer {
    font-weight: 600;
    font-style: normal !important;
}

/* typography: desktop */
@media(min-width:768px) {
    .review-container p {
        font-size: 18px;
        line-height: 26px;
    }
}

@media(min-width:992px) {

    :global(.swiper-slide) {
        padding-bottom: 10px;
    }

    .slide_container {
        flex-direction: row;
        justify-content: space-between;
        background: url('~/assets/friendly-services/hearts.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: top center;
    }


    .mobile-bg_container,
    .img_container {
        width: 25%;
    }

    .mobile-bg_container .mbl_img_container {
        height: 100%;
        width: 100%;
    }

    .review-container {
        width: 40%;
        margin: auto;
    }

    .review {
        padding-top: 30px;
    }

    
}
</style>